import Dialogs from './Dialogs';

export default Dialogs;
